'use client'

import React from 'react'
import Image from 'next/image'
import { parseBoldText } from '@utils/parseBoldText'
import { ctaRenderers } from './ctaRenderers'
import styles from './styles.module.scss'

interface CommsModalContentProps {
  isMobile: boolean
  content: any
}

const ModalContent: React.FC<CommsModalContentProps> = ({ isMobile, content }) => {
  const supportImageAttributes = content?.modal_support_image?.data?.attributes
  const { url: supportImageUrl, width: supportImageWidth, height: supportImageHeight } = supportImageAttributes || {}

  return (
    <div className={styles.modalContentWrapper}>
      <div className={styles.modalContent}>
        <h2 className={styles.modalTitle}>{content?.title}</h2>
        {content?.subtitle !== 'empty' && (
          <p className={styles.modalSubtitle}>{parseBoldText(content?.subtitle, styles.boldText)}</p>
        )}
        <div className={styles.modalCards}>
          {content?.commsCtas?.map((cta: any, idx: number) => {
            const renderCTA = ctaRenderers[cta.Type]
            if (!renderCTA) return null

            const isLast = idx === content.commsCtas.length - 1

            return (
              <div key={idx} className={`${styles.modalCard} ${styles.fullWidthCard}`}>
                {renderCTA(cta, isMobile, isLast)}
              </div>
            )
          })}
        </div>
      </div>
      {supportImageAttributes && (
        <div className={styles.modalSupportImage}>
          <Image src={supportImageUrl} alt="support-image" width={supportImageWidth} height={supportImageHeight} />
        </div>
      )}
    </div>
  )
}

export default ModalContent
